<template>
  <v-navigation-drawer
    class="navigation-widget"
    color="white"
    v-model="value"
    fixed
    temporary
  >
    <router-link to="/" class="d-flex px-2 py-4">
      <img
        v-if="informations.img"
        :src="files + informations.img"
        :alt="informations.name"
        class="d-block mx-auto navbar-brand"
      />
    </router-link>

    <div class="d-flex justify-center mb-4">
      <template v-for="(item, i) in social">
        <v-btn
          v-if="item"
          :key="i"
          :href="item.link"
          target="blank"
          class="mr-1 d-flex"
          width="40px"
          height="40px"
          icon
        >
          <v-icon color="primary" size="20">
            {{ item.icon }}
          </v-icon>
        </v-btn>
      </template>
    </div>

    <PwaButtonWidget />

    <v-divider class="grey lighten-2" />

    <v-list v-model="current" class="mt-2 px-0" nav>
      <template v-for="({ text, to }, i) in menu">
        <v-list-item
          :key="i"
          class="my-0"
          v-bind="getLinkAttrs(to, server)"
          link
        >
          <v-list-item-title
            class="primary--text text-body-1 font-weight-regular px-4"
          >
            {{ text }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { getLinkAttrs } from "../../utils/getLinkAttrs";
import { getSocial } from "../../utils/getSocial";
import PwaButtonWidget from "./PwaButtonWidget.vue";
import { menu } from "../../config";

/**
 * Instancie esse componente na App.vue
 * e use a função window.showNavigationDrawer para mostrar o menu lateral.
 */
export default {
  data() {
    return {
      current: this.$route.path,
      value: false,
      menu,
    };
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
  },
  methods: {
    show() {
      this.value = !this.value;
    },
    getLinkAttrs,
  },
  created() {
    window.showNavigationDrawer = () => this.show();
  },
  components: { PwaButtonWidget },
};
</script>

<style lang="scss" scoped>
.navigation-widget {
  .navbar-brand {
    width: 90%;
  }
}

.v-navigation-drawer--temporary {
  z-index: 999 !important;
}

.v-navigation-drawer--fixed {
  z-index: 999 !important;
}

.dropdown-menu::v-deep {
  .v-icon {
    font-size: 14px !important;
  }

  .v-list-group__header {
    margin-bottom: 0 !important;
    margin-top: 8px;
  }

  .v-list-group__items {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
</style>
